import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';

const FileUploadModal = ({ show, onClose, onUpload, uploading }) => {
  const [file, setFile] = useState(null);
  const [description, setDescription] = useState('');

  const handleKeyDown = useCallback(
    e => {
      if (e.key === 'Escape') onClose();
    },
    [onClose],
  );

  useEffect(() => {
    if (show) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [show, handleKeyDown]);

  // Reset state when modal opens
  useEffect(() => {
    if (show) {
      setFile(null);
      setDescription('');
    }
  }, [show]);

  if (!show) return null;

  const handleSubmit = () => {
    if (!file) return;
    onUpload(file, description);
  };

  return ReactDOM.createPortal(
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(15, 23, 42, 0.5)',
        backdropFilter: 'blur(4px)',
        animation: 'fileUploadOverlayIn 0.18s ease-out',
      }}
    >
      <style>{`
        @keyframes fileUploadOverlayIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes fileUploadModalIn   { from { opacity: 0; transform: scale(0.94) translateY(-8px) } to { opacity: 1; transform: scale(1) translateY(0) } }
      `}</style>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#fff',
          borderRadius: '16px',
          padding: '32px',
          width: '90%',
          maxWidth: '460px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.15), 0 0 0 1px rgba(0,0,0,0.05)',
          animation: 'fileUploadModalIn 0.22s ease-out',
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
          <h4 style={{ margin: 0, color: '#1e293b', fontWeight: 700, fontSize: '17px' }}>
            <i className="fas fa-upload" style={{ marginRight: '8px', color: '#2e496b' }} />
            Dodaj plik
          </h4>
          <button
            type="button"
            onClick={onClose}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: '18px', lineHeight: 1, padding: 0 }}
            aria-label="Zamknij"
          >
            <i className="fas fa-times" />
          </button>
        </div>

        {/* File picker */}
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#475569', marginBottom: '6px' }}>
            Plik
          </label>
          <input
            type="file"
            accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip,.rar"
            onChange={e => {
              const f = e.target.files[0] || null;
              setFile(f);
            }}
            style={{
              fontSize: '13px',
              width: '100%',
              padding: '8px',
              border: '1px solid #cbd5e1',
              borderRadius: '8px',
              background: '#f8fafc',
            }}
          />
        </div>

        {/* Description */}
        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#475569', marginBottom: '6px' }}>
            Opis (opcjonalnie)
          </label>
          <input
            type="text"
            placeholder="Opis pliku (opcjonalnie)"
            value={description}
            onChange={e => { const v = e.target.value; setDescription(v); }}
            style={{
              fontSize: '13px',
              width: '100%',
              padding: '8px 12px',
              border: '1px solid #cbd5e1',
              borderRadius: '8px',
              background: '#f8fafc',
              boxSizing: 'border-box',
            }}
          />
        </div>

        {/* Actions */}
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: '10px 24px', borderRadius: '10px', border: '1px solid #e2e8f0',
              background: '#f8fafc', color: '#475569', fontWeight: 600, fontSize: '14px',
              cursor: 'pointer',
            }}
          >
            Anuluj
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={!file || uploading}
            style={{
              padding: '10px 24px', borderRadius: '10px', border: 'none',
              background: !file || uploading ? '#94a3b8' : '#2e496b',
              color: '#fff', fontWeight: 600, fontSize: '14px',
              cursor: !file || uploading ? 'not-allowed' : 'pointer',
              transition: 'background 0.15s',
            }}
          >
            {uploading ? 'Wysylanie...' : 'Wyslij'}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default FileUploadModal;
